import React from "react";
import Link from "./Link";

export default ({ website, twitter, dribbble, instagram, linkedin }) => {
  return (
    <>
      {website && <Link icon="web">{website}</Link>}
      {twitter && (
        <Link icon="twitter" href={twitter}>
          Twitter
        </Link>
      )}
      {dribbble && (
        <Link icon="dribbble" href={dribbble}>
          Dribbble
        </Link>
      )}
      {instagram && (
        <Link icon="instagram" href={instagram}>
          Instagram
        </Link>
      )}
      {linkedin && (
        <Link icon="linkedin" href={linkedin}>
          Linkedin
        </Link>
      )}
    </>
  );
};
